const fclExportDockChargesData = {
    colNames : {
        twoSpan: '',
        twoSpan1: 'Per Container',
        twoSpan2: '',
        perShipment: 'Per BL'
    },
    initialLength: 14,
    preList: [{
            id: 1,
            chargeDescription: 'Pick-up Charges',
            currency: 'INR',
            disabled: ['perShipment']
        },
        {
            id: 2,
            chargeDescription: 'Export Customs Clearance',
            currency: 'INR',
            disabled: ['perShipment']
        },
        {
            id: 3,
            chargeDescription: 'Stuffing Charges',
            currency: 'INR',
            disabled: ['perShipment']
        },
        {
            id: 4,
            chargeDescription: 'Origin Charges',
            currency: 'INR'
        },
        {
            id: 5,
            chargeDescription: 'Origin Inland Haulage',
            currency: 'INR',
            disabled: ['perShipment']
        },
        {
            id: 6,
            chargeDescription: 'Ocean Freight',
            currency: 'USD',
            disabled: ['perShipment']
        },
        {
            id: 7,
            chargeDescription: 'Hazardous Surcharge',
            currency: 'USD',
            disabled: ['perShipment']
        },
        {
            id: 8,
            chargeDescription: 'Destination Inland Haulage',
            currency: ''
        },
        {
            id: 9,
            chargeDescription: 'Carrier Destination Charges',
            currency: ''
        },
        {
            id: 10,
            chargeDescription: 'Destination Terminal Charges',
            currency: ''
        },
        {
            id: 11,
            chargeDescription: 'Import Customs Clearance',
            currency: ''
        },
        {
            id: 12,
            chargeDescription: 'Door Delivery Charges',
            currency: '',
            disabled: ['perShipment']
        },{
            id: 13,
            chargeDescription: 'Terminal Handling Fees',
            currency: '',
                  disabled: ['perShipment']
        },{
            id: 14,
            chargeDescription: 'BL Fees',
            currency: '',
                  disabled: ['perShipment']
        }
    ]
}
export default fclExportDockChargesData